<template>
<div class="chapter">
<div class="inner_page">
<p class="sectiontop">When I was in my infancy<br/>
  The Ferris wheel appealed to me<br/>
  And fate has managed to arrange<br/>
  That fifty years have seen no change<br/>
  But never have I once denied<br/>
  I’m mighty grateful for the ride<br/>
  And my track record will evince<br/>
  I’ve gone in circles ever since.</p>
<p style="text-align:right;"><i>Monroe D. Underwood</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 05_dedicated1.vue?6cbdd360